import { Page } from '@/shared/api/pagination';
import type {
  HIActive,
  HIActiveHighLevel,
  HIActiveHighLevelCI,
  HIPropagationLink,
} from '../model/types';
import type { HICIsHistory } from '../model/hi-history';
import { type AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';

const baseURLOverride = {
  baseURL: '/api/monitoring/v4',
};

export class HIApi {
  static getCiHiTypeHistory(
    ci_id: string,
    hi_type_name: string,
    starts_at: string,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.get(
      `/hi/history/ci_id/${ci_id}/hi_type_name/${hi_type_name}`,
      {
        ...options,
        ...baseURLOverride,
        params: { starts_at },
      },
    );
  }

  static getHICIsHistory(
    cis: string[],
    range: { from: string; to: string },
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post<HICIsHistory>(
      `/hi_history/cis`,
      { range, cis },
      { ...options, ...baseURLOverride },
    );
  }

  static getAllLinksStatus(ci_ids: string[], options?: AxiosRequestConfig) {
    return monitoringInstance.post<HIPropagationLink[]>(
      `/hi/propagation/links`,
      { ci_ids },
      { ...options, ...baseURLOverride },
    );
  }

  static getActiveHighLevel(options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<HIActive>>(`/hi/active_his/high_level`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getActiveHighLevelCI(options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<HIActiveHighLevelCI>>(
      `/hi/active_his/high_level_ci`,
      {
        ...options,
        ...baseURLOverride,
        // FastAPI expects repeated list keys without square brackets.
        paramsSerializer: { indexes: null },
      },
    );
  }

  static getGroupActiveHighLevel(options?: AxiosRequestConfig) {
    return monitoringInstance.get<HIActiveHighLevel[]>(
      `/hi/active_his/group_by`,
      { ...options, ...baseURLOverride },
    );
  }

  static getActiveLevelDown(options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<HIActive>>(`/hi/active_hi/level_down`, {
      ...baseURLOverride,
      ...options,
    });
  }
}